import { Box, Typography } from '@mui/material';
import React from 'react';
import {
  numberToString,
  stringToNumber,
} from '../../../special/numberConverter';

export const MatchingPropLeadFieldNumberShow = ({ property }) => {
  const { label, publicLabel, minValue, maxValue, unit } = property;

  const hasNoValue = !minValue && !maxValue;

  return (
    <Box className="flex items-start justify-between gap-2">
      <Typography>{`${publicLabel || label}: `}</Typography>
      <Typography>
        {hasNoValue
          ? '-'
          : `${numberToString(minValue)} - ${numberToString(maxValue)} ${unit}`}
      </Typography>
    </Box>
  );
};
